import { onDocumentReady } from '@cornell-engineering/js/utils';

onDocumentReady(() => {
  console.log('Hello from the Cornell Engineering Main theme scripts!'); // eslint-disable-line

  const homeInspireRoot = document.querySelector('.home__inspire-image-wrapper');
  if (homeInspireRoot) {
    import('./components/home-inspire').then(({ HomeInspire }) => {
      new HomeInspire(homeInspireRoot);
    });
  }

  const homeVideoRoot = document.querySelector('.home-topper__figure');
  if (homeVideoRoot) {
    import('./components/home-video').then(({ HomeVideo }) => {
      new HomeVideo(homeVideoRoot);
    });
  }
});
